import Vue from 'vue'
import { directiveAria } from 'vue-a11y-utils'

Vue.directive('aria', directiveAria)
